import React from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { Button, AlertCard } from "@truevault/aquilo";
import "../../../../../pages/requestInstructions/vendor-instructions.css";
import "./shared-styles.css";

interface InstructionsButtonProps {
  vendorId: string;
  hasInstructions: boolean;
  isExpanded: boolean;
  onToggle: (vendorId: string) => void;
}

export const InstructionsButton = ({
  vendorId,
  hasInstructions,
  isExpanded,
  onToggle,
}: InstructionsButtonProps) => {
  return hasInstructions ? (
    <div className="tw-boundary instructions-button-wrapper">
      <Button color="secondary" onClick={() => onToggle(vendorId)}>
        See Instructions
        {isExpanded ? (
          <ChevronUpIcon style={{ width: "16px", height: "16px" }} />
        ) : (
          <ChevronDownIcon style={{ width: "16px", height: "16px" }} />
        )}
      </Button>
    </div>
  ) : (
    <div className="instructions-button-wrapper">
      <div className="instructions-placeholder">
        See Instructions
        <div className="instructions-placeholder-chevron" />
      </div>
    </div>
  );
};

// Component for the expanded instructions content that appears below the vendor row
interface InstructionsContentProps {
  instructions?: string;
  processingInstructions?: string;
  title?: string;
  isExpanded: boolean;
}

export const InstructionsContent = ({
  instructions,
  processingInstructions,
  title = "Instructions",
  isExpanded,
}: InstructionsContentProps) => {
  const hasInstructions = instructions || processingInstructions;
  const instructionContent = instructions || processingInstructions;

  if (!hasInstructions || !isExpanded) {
    return null;
  }

  return (
    <div className="tw-boundary" style={{ width: "100%", marginTop: "16px" }}>
      <AlertCard variant="info" showDefaultIcon={false}>
        <div style={{ fontWeight: "bold", marginBottom: "8px" }}>{title}</div>
        <div
          className="vendor-instructions"
          dangerouslySetInnerHTML={{ __html: instructionContent }}
        />
      </AlertCard>
    </div>
  );
};
